<template>
    <MainContent>
        <template #title>
            Dashboard
        </template>
        <template #subtitle>
            Wanon Niwat Hospital [WEBPORTAL WNH]
        </template>
        <template #breadcrumb>
            Dashboard
        </template>
        <template #header>
            <Overlay :showOverlay="!items.length" />
            <div class="tile-title-w-btn">
                <h3 class="title">All Dashboard</h3>
                <p>
                    <button class="btn btn-primary icon-btn" @click="openAddModal">
                        <i class="bi bi-plus-square me-2"></i> Add Checklist
                    </button>
                </p>
            </div>
        </template>
        <template #content>
            <!-- <table class="table table-bordered text-center" v-if="items.length">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                            <button class="btn btn-warning btn-sm me-2" @click="openEditModal(item)">
                                <i class="bi bi-pencil"></i>
                            </button>
                            <button class="btn btn-danger btn-sm" @click="handleDelete(item.id)">
                                <i class="bi bi-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-else class="text-center text-muted">No data available.</p> -->
            <table class="table table-bordered table-hover text-center">
                <thead class="">
                    <tr>
                        <th>#</th>
                        <th>ชื่อ-นามสกุล</th>
                        <!-- <th>รายละเอียด</th> -->
                        <th>สิทธิผู้ใช้งาน</th>
                        <th>ระบบสารสนเทศ</th>
                        <th width=100>จัดการ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredAccessList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td class="text-start">{{ item.user.name }}</td>
                        <!-- <td class="text-start">{{ item }}</td> -->
                        <td>
                            <span class="badge bg-primary" :class="{ 'bg-danger': item.role == 'admin' }">{{
                                item.role }}</span>

                        </td>
                        <td>{{ item.access.name }}</td>
                        <td>
                            <div class="btn-group btn-group-sm" role="group">
                                <button @click="editAdmin(item)" type="button" class="btn btn-warning">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button @click="handleDelete(item.id)" type="button" class="btn btn-danger">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </MainContent>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalMode === 'edit' ? 'Edit' : 'Add' }} Checklist</h5>
                    <button type="button" class="btn-close" @click="hideModal"></button>
                </div>
                <form @submit.prevent="handleSubmit">
                    <div class="modal-body">
                        <input v-model="editingItem.name" type="text" class="form-control" required
                            placeholder="Enter name">
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">
                            <i class="bi bi-floppy"></i> Save
                        </button>
                        <button type="button" class="btn btn-secondary" @click="hideModal">
                            <i class="bi bi-x-circle"></i> Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { ref, reactive, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import {
    showSuccessAlert,
    showErrorAlert,
    showCreateAlert,
    showUpdateAlert,
    showDeleteAlert,
    showConfirm
} from '@/utils/sweetalert2-utils';
import MainContent from '@/components/MainContent.vue';
import Overlay from '../components/Overlay.vue';

export default {
    name: 'Dashboard',
    components: { MainContent, Overlay },
    setup() {
        const items = ref([]);
        const modalMode = ref('add');
        const editingItem = reactive({ id: null, name: '' });

        // Fetch Data
        const fetchData = async () => {
            try {
                const { data } = await axiosInstance.get('/checklists');
                items.value = data;
            } catch (error) {
                showErrorAlert('Failed to load data.');
            }
        };

        // Delete
        const handleDelete = async (id) => {
            if (await showConfirm()) {
                try {
                    await axiosInstance.delete(`/checklists/${id}`);
                    items.value = items.value.filter(item => item.id !== id);
                    showDeleteAlert();
                } catch (error) {
                    showErrorAlert('Error deleting item.');
                }
            }
        };

        // Handle Form Submit
        const handleSubmit = async () => {
            try {
                if (modalMode.value === 'edit') {
                    await axiosInstance.put(`/checklists/${editingItem.id}`, editingItem);
                    showUpdateAlert();
                } else {
                    await axiosInstance.post('/checklists', editingItem);
                    showCreateAlert();
                }
                fetchData();
                showSuccessAlert();
                hideModal();
            } catch (error) {
                showErrorAlert('Error saving data.');
            }
        };

        // Modal Functions
        const showModal = () => {
            const modal = Modal.getOrCreateInstance(document.getElementById('exampleModal'));
            modal.show();
        };

        const hideModal = () => {
            const modal = Modal.getInstance(document.getElementById('exampleModal'));
            if (modal) modal.hide();
        };

        const openAddModal = () => {
            Object.assign(editingItem, { id: null, name: '' });
            modalMode.value = 'add';
            showModal();
        };

        const openEditModal = (item) => {
            Object.assign(editingItem, item);
            modalMode.value = 'edit';
            showModal();
        };

        onMounted(fetchData);

        return {
            items,
            editingItem,
            modalMode,
            fetchData,
            handleDelete,
            handleSubmit,
            openAddModal,
            openEditModal,
            showModal,
            hideModal
        };
    }
};
</script>

<style scoped>
.table {
    margin-top: 20px;
}
</style>
